module.exports = __webpack_public_path__ + "static/img/banner.42278f42.png";